import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Store } from '@ngrx/store';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { Observable, ReplaySubject, BehaviorSubject, merge } from 'rxjs';
import { map, takeUntil, filter } from 'rxjs/operators';

import { AppState, Selectors, Actions } from 'store/root-reducer';

import { CrpRole } from 'modules/shared/models/crp.models';
import { CrpRolesResponse, CrpRolesRequest } from 'store/models/crp.models';

export class CrpRoleDataSource implements DataSource<CrpRole> {

  private unsubscribe$: ReplaySubject<any> = new ReplaySubject<any>(1);

  sort: MatSort;
  paginator: MatPaginator;

  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  crpStore$: Observable<CrpRolesResponse> = this.store.select(Selectors.record.getCrpRoles);

  constructor(private store: Store<AppState>,
    private crpId: number) { }

  connect(collectionViewer: CollectionViewer): Observable<Array<any>> {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    /* tslint:disable:deprecation */
    merge(this.sort.sortChange, this.paginator.page)
    /* tslint:enable:deprecation */
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isLoading$.next(true);
        this.loadCrps();
      });

    return this.crpStore$
      .pipe(
        filter(res => !!res),
        map((res: CrpRolesResponse) => {
          this.paginator.length = res.count;
          this.isLoading$.next(false);
          return res.results;
        }),
        takeUntil(this.unsubscribe$)
      );
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  loadCrps(): void {
    if (this.crpId && this.paginator.pageSize && this.paginator.pageIndex >= 0) {
      const crpRequest: CrpRolesRequest = <CrpRolesRequest>{
        crpId: this.crpId,
        limit: this.paginator.pageSize,
        offset: this.paginator.pageSize * this.paginator.pageIndex
      };

      switch (this.sort.direction) {
        case 'asc':
          crpRequest.sort = `${this.sort.active}`;
          break;

        case 'desc':
          crpRequest.sort = `-${this.sort.active}`;
          break;

        default:
          crpRequest.sort = undefined;
          break;
      }

      this.store.dispatch(new Actions.record.GetCrpRoles(crpRequest));
    }
  }

  getDataSourceLength(): number {
    return this.paginator.length;
  }

}
